import { useSelector } from 'react-redux';
import { shouldHighlightAmountSelector } from 'domain/companies';

const useAgGridExcelStyles = () => {
  const shouldHighlightAmount = useSelector(shouldHighlightAmountSelector);
  return shouldHighlightAmount ? [{ id: 'amount', numberFormat: { format: 'General;[red](General)' } }] : [];
};

export default useAgGridExcelStyles;
